import axios from 'axios';
import { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Category from '../components/Category'
import surveyStyle from "./Survey.module.css";
// import './survey.module.css';
import LoaderTailSpin from '../components/LoaderTailSpin';
import Register from './Register';
import SavePopup from "../components/SavePopup";
import LoadSurveyPopup from "../components/LoadSurveyPopup";

export default function Survey() {
    // alert(2);
    const firstCtegory = "67e938f774d3d221edc963cf"
    //const firstCtegory = "register";
    //const [categoryQ, setCategoryQ] = useState("register");
    //const id = "test";    

    const [categories, setCategories] = useState()
    const [disabledBtn, setDisabledBtn] = useState(true)
    const [disabled, setDisabled] = useState([true, false])
    const [answers, setAnswers] = useState({})
    const [completed, setCompleted] = useState(0)
    const [categoryQ, setCategoryQ] = useState(firstCtegory)
    const correntCategory = useRef({})
    const categoryBox = useRef({})
    const submitInfo = useRef()
    const submitBtn = useRef()
    const navigate = useNavigate()
    const [registerData, setRegisterData] = useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const lastSavedData = useRef(null); // To store last-saved answers + form values
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showLoadModal, setShowLoadModal] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [projects, setProjects] = useState([]); // all projects for the logged-in user
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    

    useEffect(() => {
        let answersNumber = Object.keys(answers).length
        setCompleted(((answersNumber / 36.5) * 100).toFixed(1))
        
        const allQuestionsAnswered = answersNumber === 36;

        const requiredFieldsFilled = registerData?.currentUnits &&
            registerData?.proposeUnits &&
            registerData?.reachUnits &&
            registerData?.longTermUnits &&
            registerData?.projectType &&
            registerData?.address?.city &&
            registerData?.address?.cityCode &&
            registerData?.address?.street &&
            registerData?.address?.streetCode &&
            registerData?.address?.number;

        if (allQuestionsAnswered && requiredFieldsFilled) {
            setDisabledBtn(false);
            if (submitBtn.current) {
                submitBtn.current.style.background = "rgb(110, 171, 246)";
                submitBtn.current.style.cursor = "pointer";
            }
            setCompleted(100)
        } else {
            setDisabledBtn(true);
            if (submitBtn.current) {
                submitBtn.current.style.background = "rgb(110 171 246 / 52%)";
                submitBtn.current.style.cursor = "not-allowed";
            }
        }
    }, [answers, registerData]);
        

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(process.env.REACT_APP_API_URL + '/Categories');
                setCategories(result.data);
            } catch (err) {
                console.error('Error fetching categories:', err);
            }

            alert(`לפני מעבר לשאלון שימו לב כי תוכלו לשמור ולשוב לשאלון בהמשך.  
                זמן מילוי השאלון מוערך ב- 45 דקות.`);
        };

        fetchData();
    }, []);

    const moveToNextCategory = () => {
        let keys = Object.keys(correntCategory.current);
        let nextIndex = keys.indexOf(categoryQ) + 1;
/*         if (nextIndex <= 9) {
            let nextItem = keys[nextIndex];
            changeCategory(nextItem)
        } */
        if (nextIndex < keys.length) {
            let nextItem = keys[nextIndex];
            changeCategory(nextItem);
        } else if (categoryQ !== "register") {
            changeCategory("register"); // Go to register page
        }
    }
    const moveToPreviousCategory = () => {
        /* let keys = Object.keys(correntCategory.current);
        let previousIndex = keys.indexOf(categoryQ) - 1; */
        if (categoryQ === "register") {
            let keys = Object.keys(correntCategory.current).filter(key => key !== "register");
            let lastSurveyCategory = keys[keys.length - 1];
            changeCategory(lastSurveyCategory);
        } else {
            let keys = Object.keys(correntCategory.current);
            let previousIndex = keys.indexOf(categoryQ) - 1;
            if (previousIndex >= 0) {
                let previousItem = keys[previousIndex];
                changeCategory(previousItem);
            }
        }
        /* if (previousIndex >= 0) {
            let previousItem = keys[previousIndex];
            changeCategory(previousItem)
        } */
    }

    const changeCategory = (id) => {
        window.scrollTo(0, 0)
        // Handle special "register" case
        if (id === "register") {
            setDisabled([false, false]); 
            // Hide current visible category (if it's not register)
            if (categoryQ !== "register" && correntCategory.current[categoryQ]) {
                correntCategory.current[categoryQ].style.display = "none";
                if (categoryBox.current[categoryQ]) {
                    categoryBox.current[categoryQ].style.opacity = "0.5";
                }
            }
            setCategoryQ("register");
            return;
        }
        // Default category behavior for numeric or string IDs
        if (id === 0) setDisabled([true, false])
        else if (id === 9) setDisabled([false, true])
        else setDisabled([false, false])
        //correntCategory.current[categoryQ].style.display = "none"
        //categoryBox.current[categoryQ].style.opacity = "0.5"
        //setCategoryQ(id)
        //correntCategory.current[id].style.display = "block"
        //categoryBox.current[id].style.opacity = "1"
        if (correntCategory.current[categoryQ]) {
            correntCategory.current[categoryQ].style.display = "none";
        }
        if (categoryBox.current[categoryQ]) {
            categoryBox.current[categoryQ].style.opacity = "0.5";
        }
        setCategoryQ(id);
        if (correntCategory.current[id]) {
            correntCategory.current[id].style.display = "block";
        }
        if (categoryBox.current[id]) {
            categoryBox.current[id].style.opacity = "1";
        }
    };

    const handlePopupSave = async ({ email, companyName, projectName }) => {
        setShowSaveModal(false);
        const currentData = {
            email,
            companyName,
            projectName,
            projectId,
            answers,
            registerData,
        };

        // proceed with API logic here 
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/save_survey`, currentData);
            // const { surveyId } = response.data;
            console.log(response.data)
            console.log(response.data.projectId)

            console.log("Saved to DB with survey ID:", response.data.projectId);
            setProjectId(response.data.projectId);

            // Update local state to remember what was saved
            lastSavedData.current = { email, companyName, projectId, projectName };
            setProjectName(projectName);
            setHasUnsavedChanges(false);
            
            setToastMessage("השאלון נשמר בהצלחה");

            setTimeout(() => {
                setToastMessage("");
            }, 3000); // message disappears after 3 seconds

        } catch (err) {
            alert("שמירת הסקר נכשלה, אנא נסה שוב.");
            console.error(err);
            console.log(err)
        }
    }

    const handleProjectLoad = (project) => {
        console.log("Loaded project:", project);

        setAnswers(project.answers || {});
        setProjectId(project._id);
        setProjectName(project.projectName);

        const {
            currentUnits,
            projectStat,
            projectDescription,
            projectType,
            proposeUnits,
            reachUnits,
            longTermUnits,
            address,
            isPeriphery
        } = project;

        setRegisterData({
            currentUnits: currentUnits || "",
            projectStat: projectStat || "",
            projectDescription: projectDescription || "",
            projectType: projectType || "",
            proposeUnits: proposeUnits || "",
            reachUnits: reachUnits || "",
            longTermUnits: longTermUnits || "",
            address: address || {
                city: project.address?.city || "",
                cityCode: project.address?.cityCode || "",
                street: project.address?.street || "",
                streetCode: project.address?.streetCode || "",
                number: project.address?.number || "",
                eshkol: project.address?.eshkol || ""
            },
            isPeriphery: project.isPeriphery ?? null
        });
        
        lastSavedData.current = {
            email: project.email,
            companyName: project.companyName,
            projectName: project.projectName,
        };
        if (!project || !project._id) {
            setToastMessage("שגיאה בטעינת פרויקט.");
            setTimeout(() => setToastMessage(""), 3000);
            return;
        }
        setToastMessage("השאלון נטען בהצלחה");
        setTimeout(() => setToastMessage(""), 3000);
    };

    const handleNewProject = () => {
        // clear answers + register data
        setAnswers({});
        setRegisterData({
            currentUnits: "",
            projectStat: "",
            projectDescription: "",
            projectType: "",
            proposeUnits: "",
            reachUnits: "",
            longTermUnits: "",
            address: {
            city: "",
            cityCode: "",
            street: "",
            streetCode: "",
            number: "",
            eshkol: ""
            },
            isPeriphery: null
        });

        // clear project metadata
        setProjectId(null);
        setProjectName("");
        setSelectedProjectId(null); // also clear dropdown selection if you have it
        lastSavedData.current = {};

        // clear unsaved changes flag
        setHasUnsavedChanges(false);

        // optional: notify user
        setToastMessage("פרויקט חדש נפתח");
        setTimeout(() => setToastMessage(""), 3000);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (Object.keys(answers).length === 36) {
            submitInfo.current.style.color = 'black'
            submitInfo.current.innerText = 'בקשת השליחה התקבלה.'
            let response = await axios.post(process.env.REACT_APP_API_URL + '/done' , { answers, registerData, projectId, });
            if (response.data.status === 200) {
                setProjectId(response.data.projectId); // Store if newly created
                navigate(`/certificate/${response.data.projectId}`);
            } else {

                submitInfo.current.style.color = 'red'
                submitInfo.current.innerText = 'בעיה בשליחת הסקר, אנא נסה שנית.'
                // alert('הטופס לא נשלח, נא נסה שנית יותר מאוחר') 
            }
        }
        // else alert('יש לענות על כל השאלות')
    }

    const handleChange1 = (event) => {
        let name = event.target.name
        let value = event.target.value
        setAnswers(prev => {
            const updated = { ...prev, [name]: value };
            setHasUnsavedChanges(true);
            return updated;
        });
        /* setAnswers({ ...answers, [name]: value }) */
    }

    const handleChange2 = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        setAnswers(prev => {
            const arrAns = prev[name] || [];
            // const updatedArr = event.target.checked ? [...arrAns, value] : arrAns.filter(el => el !== value);
            const updatedArr = event.target.checked ? Array.from(new Set([...arrAns, value])) : arrAns.filter(el => el !== value);
            setHasUnsavedChanges(true);
            return { ...prev, [name]: updatedArr };
        });
    }

    const updateRegisterData = (newData) => {
        setRegisterData(newData);
        setHasUnsavedChanges(true);
    };

    // console.log(isLoggedIn, projectId, !projectId)

    if (categories)
        return <div>
            <div className={surveyStyle.categoriesLine}>
                {categories.map(val => {
                    if (!val || !val._id || !val.icon || !val.icon[0]) return null;
                    //console.log("Categories:", categories);
                    return <Category key={val._id} onClick={() => changeCategory(val._id)} category={val} >
                        <img
                        src={val.icon[0].imageURL}
                        style={{ opacity: categoryQ === val._id ? "1" : "0.5" }}
                        ref={el => (categoryBox.current[val._id] = el)}
                        alt={val.icon[0].altText || ''}
                        />
                    </Category>
                })}
                <Category onClick={() => changeCategory("register")} key="register">
                    <img src="/icons/test.svg"
                        style={{ opacity: categoryQ === "register" ? "1" : "0.5" }}
                        alt="Register"
                    />
                </Category>
            </div>
            <div className={surveyStyle.progressContainer}>
                <div className={surveyStyle.progressFiller} style={{ width: `${completed}%` }}>
                    <span className="progress-label">{`${completed}%`}</span>
                </div>
            </div>
            <div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.2rem' }} ref={submitInfo}></div>
            <form className={surveyStyle.formQuestion} onSubmit={handleSubmit}>
                <div style={{ display: 'flex', placeContent: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    
                    <div style={{ fontSize: '1.5rem', marginRight: '1rem' }}>
                        שם הפרויקט:{' '}
                            {projectName ? (
                                projectName
                            ) : (
                                <span style={{ color: '#888', fontStyle: 'italic' }}>טרם נבחר</span>
                            )}
                    </div>
{/*                         שם הפרויקט: {projectName}</div>
 */}                    
                    {isLoggedIn && projects.length > 0 && (
                        <div className="project-dropdown">
                            <label>
                            <select
                                value={selectedProjectId || ""}
                                onChange={async (e) => {
                                const id = e.target.value;
                                setSelectedProjectId(id);

                                if (!id) return;

                                // Fetch full project from backend
                                const res = await axios.get(
                                    `${process.env.REACT_APP_API_URL}/project-data/${id}`
                                );
                                handleProjectLoad(res.data); // pass full project object

                                /* // call your existing project loader
                                handleProjectLoad(id); */
                                }}
                            >
                                <option value="" disabled>בחרו פרויקט</option>
                                {projects.map((p) => (
                                <option key={p._id} value={p._id}>
                                    {p.projectName}
                                </option>
                                ))}
                            </select>
                            </label>
                        </div>
                    )}
                        
                    <input
                        type="button"
                        key="save"
                        onClick={() => {
                            if (!hasUnsavedChanges) return;
                            if (!projectId) {
                                // first time saving
                                setShowSaveModal(true);
                            } else {
                                // Already defined project
                                handlePopupSave({projectName, companyName: lastSavedData.current?.companyName, email: lastSavedData.current?.email})
                        }}}
                        
                        disabled={!hasUnsavedChanges}
                        style={{
                            margin: '0.5rem',
                            fontFamily: 'Assistant-Bold, Assistant',
                            fontSize: '24px',
                            borderRadius: '50px',
                            border: 'none',
                            background: hasUnsavedChanges ? 'rgb(110, 171, 246)' : 'rgba(110, 171, 246, 0.52)',
                            color: 'white',
                            padding: '7px 31px',
                            cursor: hasUnsavedChanges ? 'pointer' : 'not-allowed'
                        }}
                        value="שמירה"
                    />

                    <button
                        type="button"
                        key="load"
                        onClick={(isLoggedIn && projectId) ? handleNewProject : () => setShowLoadModal(true)}
                        style={{
                            margin: '0.5rem',
                            fontFamily: 'Assistant-Bold, Assistant',
                            fontSize: '24px',
                            borderRadius: '50px',
                            border: 'none',
                            background: (isLoggedIn && projectId) ? '#355279' : '#888', // conditional background
                            color: 'white',
                            padding: '7px 15px',
                            cursor: 'pointer'
                        }}
                        
                    >
                        {(isLoggedIn && projectId) ? "יצירת פרויקט חדש" : "טעינת שאלון קיים"}
                    </button>
                    
                    <input type="submit" key="done" ref={submitBtn} disabled={disabledBtn} onClick={handleSubmit} style={{ margin: '0.5rem 0.5rem 0.5rem 0.5rem', fontFamily: 'Assistant-Bold, Assistant', fontSize: '24px', borderRadius: '50px', border: 'none', background: 'rgb(110 171 246 / 52%)', color: 'rgb(255, 255, 255)', padding: '7px 31px', cursor: 'not-allowed' }} value="שליחה" />
                    
                </div>
                
                {toastMessage && (
                    <div className={surveyStyle.toastMessage}>
                        {toastMessage}
                    </div>
                )}


                {categories.map((val, i) => {
                    return <div className='categoryQuestions' ref={el => correntCategory.current[val._id] = el}
                        style={(val._id === firstCtegory) ? {} : { display: "none" }} >
                        <Questions categoryID={val._id} key={val._id} handleChange1={handleChange1} answers={answers} handleChange2={handleChange2} />
                    </div>
                })
                }
                {categoryQ === "register" && (
                    <div className='categoryQuestions'
                        ref={el => correntCategory.current["register"] = el}
                        style={{ display: categoryQ === "register" ? "block" : "none" }}>
                        {/* style={{ display: "block", pointerEvents: "none", opacity: 0.5 }}> */}
                        <Register registerData={registerData} setRegisterData={updateRegisterData} />
                    </div>
                )}
            </form>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <button onClick={moveToPreviousCategory} className={surveyStyle.circularBtn} disabled={disabled[0]}>&#8249;</button>
                <button onClick={moveToNextCategory} className={surveyStyle.circularBtn} disabled={disabled[1]} >&#8250;</button>
            </div>
            {showSaveModal && (
                <SavePopup
                    onClose={() => setShowSaveModal(false)}
                    onSave={handlePopupSave}
                    hasUnsavedChanges={hasUnsavedChanges}
                    existingData={lastSavedData.current || {}}
                />
            )}
            {showLoadModal && (
                <LoadSurveyPopup
                    onClose={() => setShowLoadModal(false)}
                    onLogin={(email, projects) => {
                        setUserEmail(email); // Store the logged-in email for later use
                        setIsLoggedIn(true);
                        setProjects(projects);
                    }}
                    onLoad={(project) => handleProjectLoad(project)}
                />
            )}
        </div>
    else
        return <div style={{ 
            fontSize: '1.5rem',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '2rem' // adjust how far from the top
        }}>
            מעלה שאלון...
        </div>

}

function Questions({ categoryID, handleChange1, handleChange2, answers }) {
    const [questions, setQuestions] = useState([])

    useEffect(correntCategory, [])

    function correntCategory() {
        axios.get(process.env.REACT_APP_API_URL + `/Questions?category=${categoryID}`)
            .then(result => {
                setQuestions(result.data)
            })
            .catch((err) => console.log(err))
    }


    if (questions)
        return <>
            {questions.map(question => {
                
                return (
                    <div style={{ background: "white", margin: "15px", padding: "4px" }}>
                        {/* <div className='qustion' style={{ display: "flex", alignItems: "center" }}> */}
                        {/* <div className='qustion' style={{ display: "flex", alignItems: "flex-start" }}> */}
                        <div className={surveyStyle["question_wrapper"]} >
                            {/* <div style={{ display: "flex", alignItems: "center" }}> */}
                                <div className={surveyStyle['question_num']}>
                                    <div>שאלה {question.order}</div>
                                    {question.help && (
                                            <div className={surveyStyle['tooltip-wrapper']}>
                                                <span class="material-symbols-outlined">help</span>
                                                {/* <span className={surveyStyle['tooltip-icon']}>i</span> */}
                                                <div className={surveyStyle['tooltip-box']} dangerouslySetInnerHTML={{ __html: question.help }} />
                                            </div>
                                        )}
                                </div>
                                {/* <div style={{ margin: "8px 3px 8px 8px", position: "relative" }}> */}
                                {/* <div style={{ margin: "8px 3px 8px 8px", flexGrow: 1 }}> */}
                                <div className={surveyStyle['question_text']}>
                                    <div className={surveyStyle["question_main"]}>
                                        
                                        <div dangerouslySetInnerHTML={{ __html: question.question }} />
                                        
                                    </div>
                                {/* </div>    */} 
                                    
                                    {question.questionsubtext && (
                                        <div className={surveyStyle["question_subtext"]} dangerouslySetInnerHTML={{ __html: question.questionsubtext }}></div>
                                    )}
                                
                                {/* <h4 style={{ margin: "8px 3px 8px 8px" }} title={question.help || ""} dangerouslySetInnerHTML={{ __html: question.question }} /> */}
                                {(question.type.value === "multi_chose") ? <p>*בשאלה זו ניתן לבחור מספר תשובות</p> : ''}
                            </div>
                        </div>    
                        
                            


                        <div style={{ display: "flex", flexDirection: "column", marginTop: "8px" }}>
                            {(question.type.value === "single")
                            ?
                            question.answers.map(answer => { // Radio.
                                let checked = Boolean((question._id in answers) && (answers[question._id] === answer._id))
                                return <label onChange={handleChange1} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }} >
                                    <span style={{ minWidth: "65px", fontSize: "0.90rem", display: "inline-block", textAlign: "center" }}>{answer.score} נק'
                                     <br />
                                        {answer.link && (<a href={answer.link} target="_blank" rel="noopener noreferrer"
                                            style={{ fontSize: "11px", color: "#1a73e8", textDecoration: "underline" }}
                                        >מידע </a>
                                        )}
                                    </span>
                                
                                    <input key={answer._id} type="radio"
                                        value={answer._id}
                                        name={question._id}
                                        checked={checked}
                                        required /> 
                                    {answer.answer}
                                
                                </label>

                            })
                            :
                            question.answers.map(answer => { // Checkbox.
                                let checked = Array.isArray(answers[question._id]) && answers[question._id].includes(answer._id);
                                return <label required style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                    <span style={{ minWidth: "65px", fontSize: "0.90rem", display: "inline-block", textAlign: "center" }}>{answer.score} נק'
                                        <br />
                                        {answer.link && (<a href={answer.link} target="_blank" rel="noopener noreferrer"
                                            style={{ fontSize: "11px", color: "#1a73e8", textDecoration: "underline" }}
                                        >מידע </a>
                                        )}
                                    </span>
                                    <input key={answer._id} type="checkbox" value={answer._id} onChange={handleChange2} checked={checked} name={question._id} />
                                    {answer.answer}
                                </label>
                            })}
                        </div>
                    </div>
            )
            })}
        </>
    else return <LoaderTailSpin />
}


